import { Analyzer, AnalyzerFindRelations, Snapshot } from 'types';

export const getColor = (
  item: Analyzer | AnalyzerFindRelations | undefined
) => {
  if (!item) return 'blue';
  if (!item.enabled) {
    return '#FF505F';
  } else if (!item.status && item.enabled) {
    return '#FCC419';
  } else if (item.status && item.enabled) {
    return '#21CC66';
  } else {
    return 'blue';
  }
};

export const getConnection = (
  item: Analyzer | AnalyzerFindRelations | undefined
) => {
  if (!item) return 'Unknown';
  if (!item.enabled) {
    return 'Disconnected';
  } else if (!item.status && item.enabled) {
    return 'Unit Lost';
  } else if (item.status && item.enabled) {
    return 'Connected';
  } else {
    return 'Unknown';
  }
};

export const getMode = (item: Analyzer | AnalyzerFindRelations | undefined) => {
  if (!item) return 'N/A';
  if (item.mode === 0) {
    return 'Live';
  } else {
    return 'Polling';
  }
};

export const getActiveSnapshot = (
  item: Analyzer | AnalyzerFindRelations | undefined,
  snapshots: Snapshot[] | undefined
) => {
  if (!item) return 'N/A';
  if (item.mode === 0) {
    const snapshot = snapshots?.find(
      (snapshot) => snapshot.id === item?.active_snapshot
    );
    return snapshot?.name;
  } else {
    return 'N/A';
  }
};
